
import AppData from './AppData';
import MenuItem, { SideDishMode } from './MenuItem';
import React from "react";
import { v4 as uuidv4 } from 'uuid';
/**
 * @callback getMenuItem
 * @param {Boolean} useCache
 * @returns {MenuItem}
 */

function OrderItem(v) {
    this.category = -1
    this.menuItem = -1

    // To keep track of how many times this object had been cloned
    this.v = v || 0

    this.uuid = uniqueUuid()

    /** @type {getMenuItem} */
    this.getMenuItem = this.getMenuItem.bind(this)
    this.getCategory = this.getCategory.bind(this)
    this.getUnitPrice = this.getUnitPrice.bind(this)
    this.isSideDishCompleted = this.isSideDishCompleted.bind(this)
    this.getSideDishGroupSelectedQuantity = this.getSideDishGroupSelectedQuantity.bind(this)
}

const uuids = {}
export function uniqueUuid() {
    let uuid = uuidv4()
    while (uuids[uuid]) {
        uuid = uuidv4()
    }
    uuids[uuid] = true
    return uuid
}
OrderItem.prototype.getUnitPrice = function() {
    let unitPrice = 0
    if (this.unit_price) {
        return this.unit_price
    }
    let menuItem = this.getMenuItem()
    if (this.option_ids) {
        let choice = AppData.data.state.variation.choices.find((item) => item.id == this.option_ids[0])
        if (choice) {
            unitPrice = parseFloat(choice.price);
        }
    }
    else if (menuItem) {
        unitPrice = parseFloat(menuItem.price)
    }
    return unitPrice
}
OrderItem.prototype.getMenuItem = function(useCache) {
    if (useCache && this.menuItem != -1) {
        return this.menuItem
    }
    this.menuItem = AppData.data.state.menuItems.find(menuItem => menuItem.id == this.menu_item_id)
    return this.menuItem
}
OrderItem.prototype.getCategory = function(useCache) {
    if (useCache && this.category != -1) {
        return this.category
    }
    this.category = this.getMenuItem(true) && this.getMenuItem(true).getCategory()
    return this.category
}
OrderItem.prototype.getSideDishGroupSelectedQuantity = function(group) {
    let { side_dish_data = {} } = this
    let selections = side_dish_data.selections ? [...side_dish_data.selections] : []
    let totalSideDishSelected = selections.reduce((total,selection) => {
        if (selection.variation.group == group) {
            total += parseInt(selection.quantity)
        }
        return total
    }, 0)
    return totalSideDishSelected
}
OrderItem.prototype.isSideDishCompleted = function() {
    let menuItem = this.getMenuItem()
    if (!menuItem) {
        return true
    }
    let { sideDishes } = menuItem.getVariations()
    if (!sideDishes || sideDishes.length == 0 || this.order_status !== 'draft') {
        return true
    }

    let isSideDishCompleted = {}
    let sideDishDetail = menuItem.side_dish_detail
    sideDishDetail.forEach(sdd => {
        let totalSideDishSelected = this.getSideDishGroupSelectedQuantity(sdd.group)
        const sideDishMode = sdd.side_dish_mode && parseInt(sdd.side_dish_mode) || SideDishMode.MUST_SELECT
        switch (sideDishMode) {
            case SideDishMode.MUST_SELECT:
                isSideDishCompleted[sdd.group] = totalSideDishSelected == menuItem.getMaxSideDish(sdd.group)
                break
            case SideDishMode.SELECT_UP_TO:
                isSideDishCompleted[sdd.group] = totalSideDishSelected <= menuItem.getMaxSideDish(sdd.group)
                break
            case SideDishMode.SELECT_BETWEEN:
                isSideDishCompleted[sdd.group] = totalSideDishSelected >= menuItem.getMinSideDish(sdd.group) && totalSideDishSelected <= menuItem.getMaxSideDish(sdd.group)
                break
        }
    })
    return isSideDishCompleted
}

/**
 * Use this to clone OrderItem. This will only copy the properties and ignore the functions.
 * Functions have bindings where after clone will still point 'this' to the old object, making
 * later internal calculations function to return wrong results
 *
 * @param {OrderItem} order
 * @returns
 */
export const cloneOrder = (order, otherProperties = {}) => {
    order.v++   // Keep track of how many times we have clone
    return Object.assign(new OrderItem(), JSON.parse(JSON.stringify(order)), otherProperties)
}

const newSelectionItem = (variation) => {
    return {
        variation_id: variation.id,
        quantity    : 1,
        variation   : { ...variation },
    }
}

const handleQuantityChange = ({selections, variation, overMaxQuantity, isAdd, defaultMax}) => {
    const index = selections.findIndex(sd => sd.variation_id == variation.id)
    let selection = null
    if (index !== -1) {
        selection = selections[index]
    }

    let currentItemQuantity = 0
    if (index === -1 && isAdd) {
        // First time adjusting quantity for this side dish item, create the record

        let newItem = newSelectionItem(variation)
        currentItemQuantity = newItem.quantity
        selections.push(newItem)
    }
    else if (index !== -1) {
        selection = selections[index]
        if (isAdd) {
            let max = variation.max ? variation.max : defaultMax
            if (!max || selection.quantity < max) {
                selection.quantity++
            }
            else {
                // Over max quantity, take note and later return this info to caller
                overMaxQuantity && overMaxQuantity.push(variation.id)
            }
        }
        else {
            selection.quantity--
            if (selection.quantity <= 0) {
                // User set to 0 quantity, remove it from array
                selections.splice(index, 1)
                currentItemQuantity = 0
            }
        }
        currentItemQuantity = selection.quantity
    }

    return {
        selections,
        overMaxQuantity,
        currentItemQuantity,
    }
}

export const handleVariationQuantityChange = ({ order, variation, isAdd, }) => {
    let menuItem = order.getMenuItem()
    let { variation_data = {} , } = order
    let _selections = variation_data.selections ? [...variation_data.selections] : []

    let _overMaxQuantity = []
    let { overMaxQuantity, selections, currentItemQuantity, } = handleQuantityChange({selections: _selections, overMaxQuantity: _overMaxQuantity, variation, isAdd, defaultMax: variation.max || 5})

    variation_data.selections = selections
    order.variation_data = {...variation_data}

    return {
        order: cloneOrder(order),
        overMaxQuantity,
        currentItemQuantity,
    }
}

export const toggleSideDish = ({order, sideDish}) => {
    let { side_dish_data = {} , } = order
    let selections = side_dish_data.selections || []

    let isAddNewItem = true
    if (selections.length) {
        const index = selections.findIndex(v => v.variation_id == sideDish.id)
        if (index !== -1) {
            // Remove
            isAddNewItem = false
            selections.splice(index, 1)
        }
    }

    // Handle add item
    if (isAddNewItem) {
        let isSkip = isWillOverMaxQuantityAfterAdd(order, sideDish)
        if (!isSkip) {
            selections.push(newSelectionItem(sideDish))
        }
    }

    side_dish_data.selections = selections
    order.side_dish_data = { ...side_dish_data }

    return {
        order: cloneOrder(order),
    }
}

const isWillOverMaxQuantityAfterAdd = (order, sideDish) => {
    let menuItem = order.getMenuItem()
    const sideDishMode = menuItem.getSideDishMode(sideDish.group)
    const maxQuantity = menuItem.getMaxSideDish(sideDish.group)
    let isSideDishCompleted = order.isSideDishCompleted()
    if (isSideDishCompleted[sideDish.group]) {
        let sideDishGroupSelectedQuantity = order.getSideDishGroupSelectedQuantity(sideDish.group)
        if (sideDishMode == SideDishMode.MUST_SELECT) {
            return true
        }
        else if ([SideDishMode.SELECT_UP_TO, SideDishMode.SELECT_BETWEEN].indexOf(sideDishMode) !== -1) {
            if (sideDishGroupSelectedQuantity + 1 > maxQuantity) {
                return true
            }
        }
    }
    return false
}

export const handleSideDishChange = ({ order, sideDish, isAdd, sideDishOverMaxQuantity, }) => {
    let { side_dish_data = {} , } = order
    let selections = side_dish_data.selections ? [...side_dish_data.selections] : []

    const index = selections.findIndex(sd => sd.variation_id == sideDish.id)
    let selection = null
    if (index !== -1) {
        selection = selections[index]
    }

    let isSkip = isAdd && isWillOverMaxQuantityAfterAdd(order, sideDish)
    if (!isSkip) {
        if (index === -1 && isAdd) {
            // First time adjusting quantity for this side dish item, create the record
            let newSideDishItem = {
                variation_id: sideDish.id,
                quantity    : 1,
                variation   : { ...sideDish },
            }
            selections.push(newSideDishItem)
        }
        else if (index !== -1) {
            if (isAdd) {
                if (!sideDish.max_quantity || selection.quantity < sideDish.max_quantity) {
                    selection.quantity++
                }
                else {
                    // Over max quantity, take note and later return this info to caller
                    sideDishOverMaxQuantity && sideDishOverMaxQuantity.push(sideDish.id)
                }
            }
            else {
                selection.quantity--
                if (selection.quantity <= 0) {
                    // User set to 0 quantity, remove it from array
                    selections.splice(index, 1)
                }
            }
        }
        side_dish_data.selections = selections
        order.side_dish_data = {...side_dish_data}
    }

    return {
        order: cloneOrder(order),
        sideDishOverMaxQuantity,
    }
}

export const getSideDishMessage = ({order, sideDish, isSideDishCompleted, sdd}) => {
    const menuItem = order.getMenuItem()
    let minSideDish = menuItem.getMinSideDish(sdd.group)
    let maxSideDish = menuItem.getMaxSideDish(sdd.group)

    let sideDishMessage = "Unknown"
    let isCompletedMessage = isSideDishCompleted[sdd.group] && <span className="fa fa-check text-success pull-right"></span>

    let currentSideDishQuantity = order.getSideDishGroupSelectedQuantity(sdd.group)
    if (currentSideDishQuantity < maxSideDish) {
        isCompletedMessage = lang.side_dish_hint_can_choose_more.replace('%s', maxSideDish - currentSideDishQuantity)
    }
    let sideDishMode = sdd.side_dish_mode && parseInt(sdd.side_dish_mode) || SideDishMode.MUST_SELECT

    switch (sideDishMode) {
        case SideDishMode.MUST_SELECT:
            sideDishMessage = lang.side_dish_hint_must_select.replace("%s", maxSideDish)
            if (currentSideDishQuantity < maxSideDish) {
                isCompletedMessage = lang.side_dish_hint_please_choose_more.replace('%s', maxSideDish - currentSideDishQuantity)
            }
            break
        case SideDishMode.SELECT_UP_TO:
            sideDishMessage = lang.side_dish_hint_select_up_to.replace("%s", maxSideDish)
            if (currentSideDishQuantity < maxSideDish) {
                isCompletedMessage = lang.side_dish_hint_can_choose_more.replace('%s', maxSideDish - currentSideDishQuantity) + ` (${lang.optional})`
            }
            break
        case SideDishMode.SELECT_BETWEEN:
            sideDishMessage = lang.side_dish_hint_select_between.replace("%s1", minSideDish).replace("%s2", maxSideDish)
            if (currentSideDishQuantity < minSideDish) {
                isCompletedMessage = lang.side_dish_hint_please_choose_more.replace('%s', minSideDish - currentSideDishQuantity)
            }
            else if (currentSideDishQuantity < maxSideDish) {
                isCompletedMessage = lang.side_dish_hint_can_choose_more.replace('%s', maxSideDish - currentSideDishQuantity) + ` (${lang.optional})`
            }
            break
        default:

    }

    return {
        isCompletedMessage, sideDishMessage
    }
}

export default OrderItem;
